import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
const RFQMenu = () => {
 
  return (
    <div > 
      
     <Navbar style={{backgroundColor:"#2F9DCC"}} className='d-flex justify-content-left'>
    
          <Nav>
            <Nav.Link as={Link} to="/Dashboard" className='text-white'>Home</Nav.Link>
             <Nav.Link as={Link} to="/CustomersInsights" className='text-white'>Customers </Nav.Link>
            <Nav.Link as={Link} to="/AgentsInsights" className='text-white'> Agents </Nav.Link>
            <Nav.Link as={Link} to="/" className='text-white'>Sales</Nav.Link>
            <Nav.Link as={Link} to="/" className='text-white'>Compliance</Nav.Link>
          </Nav>
          </Navbar>
    
    </div>
  )
}

export default RFQMenu
